import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card mb-xl-10 border border-primary comentarios mb-5 mx-9 mt-10" }
const _hoisted_3 = { class: "card-body p-1 py-5 m-0" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle fs-1 text-primary" })
], -1)
const _hoisted_6 = { class: "fs-4 fw-bold mb-3 col-11" }
const _hoisted_7 = { class: "mb-3 landingSubtitle" }
const _hoisted_8 = { class: "fs-7 fw-normal me-5" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "card mb-xl-10 border border-primary comentarios mb-5 mx-9" }
const _hoisted_11 = { class: "card-body p-1 py-5 m-0" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle fs-1 text-primary" })
], -1)
const _hoisted_14 = { class: "fs-4 fw-bold mb-3 col-11" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "fs-7 fw-normal me-5" }
const _hoisted_17 = { href: "mailto:iam@aragon.es" }
const _hoisted_18 = {
  id: "kt_app_content",
  class: "app-content flex-column-fluid mt-10"
}
const _hoisted_19 = {
  id: "kt_app_content_container",
  class: "app-container container-xxl"
}
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = {
  class: "stepper stepper-links d-flex flex-column pt-10 first",
  id: "kt_create_account_stepper",
  "data-kt-stepper": "true",
  ref: "horizontalWizardRef"
}
const _hoisted_23 = { class: "stepper-nav mb-5" }
const _hoisted_24 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_25 = { class: "stepper-title" }
const _hoisted_26 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_27 = { class: "stepper-title" }
const _hoisted_28 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_29 = { class: "stepper-title" }
const _hoisted_30 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_31 = { class: "stepper-title" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_33 = { "data-kt-stepper-element": "content" }
const _hoisted_34 = { "data-kt-stepper-element": "content" }
const _hoisted_35 = { "data-kt-stepper-element": "content" }
const _hoisted_36 = { class: "d-flex flex-stack pt-5" }
const _hoisted_37 = { class: "mr-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" })
], -1)
const _hoisted_39 = ["data-kt-indicator", "disabled"]
const _hoisted_40 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 ms-2 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)
const _hoisted_42 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_44 = {
  key: 1,
  class: "btn btn-lg btn-success",
  disabled: ""
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 ms-1 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isTest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("plantilla.title")), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("plantilla.text")), 1)
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("solicitudTextoInformativo.title")), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$t("solicitudTextoInformativo.text")) + " ", 1),
                    _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t("solicitud.correo")) + ". ", 1)
                  ])
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t("solicitud.proyecto")), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t("solicitud.cuidados")), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t("solicitud.empleo")), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t("solicitud.valoracion")), 1)
                ])
              ]),
              _createElementVNode("form", {
                class: "mx-auto mw-900px w-100 pt-0 pb-10",
                novalidate: "novalidate",
                id: "kt_create_account_form",
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Step1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Step2)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_Step3)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_Step4)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                    }, [
                      _hoisted_38,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("atrasBtn")), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1 && !_ctx.isSent)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          class: "btn btn-lg btn-primary me-3",
                          "data-kt-stepper-action": "submit",
                          "data-kt-indicator": _ctx.isPendingForm ? 'on' : null,
                          disabled: _ctx.isTest || _ctx.isSent
                        }, [
                          (!_ctx.isPendingForm && !_ctx.isSent)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                _createTextVNode(_toDisplayString(_ctx.$t("enviarBtn")) + " ", 1),
                                _hoisted_41
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isPendingForm && !_ctx.isSent)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                _createTextVNode(_toDisplayString(_ctx.$t("enviandoBtn")) + " ", 1),
                                _hoisted_43
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_39))
                      : (_ctx.isSent)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_44, _hoisted_46))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "submit",
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.paso2 && _ctx.paso2(...args)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("continuarBtn")) + " ", 1),
                            _hoisted_47
                          ]))
                  ])
                ])
              ], 32)
            ], 512)
          ])
        ])
      ])
    ])
  ], 64))
}